import {Component, Prop} from "vue-property-decorator";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal.vue";
import Modal from "@/assets/common/Modal/Modal.vue";

@Component({
    components: {
        Modal
    }
})
export default class MachineSelectModal extends ItemSelectModal {
    @Prop({default: () => "機械"})
    itemKindName!: string

    @Prop({default: () => "/machines"})
    apiPath!: string;

    @Prop({default: () => true})
    multiple!: boolean

    // バリデーションチェックパラメータのオーバーライド
    validateParam = { nameLength: 100 }
}
